import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-facility-note',
    templateUrl: './breadcrumb.facility.note.component.html'
})

export class BreadcrumbFacilityNotesComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() facilityId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
